import React from "react";
import { MdSearch } from "react-icons/md";
const SortingSection = () => {
  return (
    <div className="py-3 d-flex flex-column flex-lg-row justify-content-between align-items-center">
      {/* <div className="border px-2 py-1">
        <MdSearch />
        <input
          type="text"
          placeholder="Search reviews"
          className="border-0 ps-1"
          style={{ outline: "0" }}
        />
      </div> */}
      <span
        className="fw-bold pb-2 mt-2"
        style={{ borderBottom: "3px solid black", width: "7.8125rem" }}
      >
        Product Reviews
      </span>
    </div>
  );
};

export default SortingSection;
